import Field from 'components/Form/Field';
import Layout from 'components/Layout';
import Value from 'components/Value';
import {ClientInboxDocument} from 'pages/Portal/services';
import {FC} from 'react';
import {t} from 'ttag';
import {jstDateTimeString} from 'utils/date';

import {isDocumentType} from '../utils';

type DocumentInformationProps = {
    document: ClientInboxDocument;
    isZipFile: boolean;
};

const DocumentInformation: FC<DocumentInformationProps> = ({
    document,
    isZipFile,
}) => {
    const date = jstDateTimeString(new Date(document.dateSent));

    const jst = t`JST`;

    return (
        <Layout.KeyValue>
            <Field label={t`Received`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: `${date} ${jst}`,
                    }}
                />
            </Field>
            <Field label={t`Document`} type="value">
                <Value
                    value={{
                        type: 'string',
                        value: isZipFile
                            ? document.filename
                            : document.displayName,
                    }}
                />
            </Field>
            {isDocumentType(document) && (
                <>
                    {document.projectName && (
                        <Field label={t`Project`} type="value">
                            <Value
                                value={{
                                    type: 'string',
                                    value: document.projectName,
                                }}
                            />
                        </Field>
                    )}
                    {document.total && document.hasTotals && (
                        <Field label={t`Total`} type="value">
                            <Value
                                value={{
                                    type: 'string',
                                    value: document.total,
                                }}
                            />
                        </Field>
                    )}
                    {document.amountToPay && (
                        <Field label={t`Amount to Pay`} type="value">
                            <Value
                                value={{
                                    type: 'string',
                                    value: document.amountToPay,
                                }}
                            />
                        </Field>
                    )}
                    {document.addressee && (
                        <Field label={t`Attention`} type="value">
                            <Value
                                value={{
                                    type: 'string',
                                    value: document.addressee,
                                }}
                            />
                        </Field>
                    )}
                </>
            )}
            {document.fileSize && (
                <Field label={t`File Size`} type="value">
                    <Value
                        value={{
                            type: 'string',
                            value: document.fileSize,
                        }}
                    />
                </Field>
            )}
        </Layout.KeyValue>
    );
};

export default DocumentInformation;
